// URLの有効性を確認する
export default function ping(url: string): Promise<void> {
    return new Promise((resolve, reject) => {
        const req = new XMLHttpRequest();
        req.open('HEAD', url);
        req.onload = () => {
            resolve();
        };
        req.onerror = (err) => {
            reject(err);
        };
        req.send();
    });
}
